<template v-if="list.length" lang="html">
  <table class="admin-table vacancies-table">
    <thead>
      <tr>
        <th class="column-id"></th>

        <th class="column-name" @click="setSortingMethod('name')">
          {{ $tr('admin_console.company.vacancies.name') }}
          <i v-if="sorting.name === 'name'" class="fa" :class="sortingIcon"></i>
        </th>

        <th class="column-date" @click="setSortingMethod('created_at')">
          <span>{{ $tr('common.list.created') }}</span>
          <i v-if="sorting.name === 'created_at'" class="fa" :class="sortingIcon"></i>
        </th>

        <th class="column-owner">
          <div>
            {{ $tr('admin_console.company.vacancies.candidates') }}
          </div>
        </th>

        <th class="column-owner">
          {{ $tr('admin_console.company.vacancies.creator') }}
        </th>

        <th class="column-recruiters">
          {{ $tr('admin_console.company.vacancies.managers') }}
        </th>

        <th class="column-recruiters">
          {{ $tr('admin_console.company.vacancies.instruments') }}
        </th>

        <th class="column-recruiters"></th>
      </tr>
      <tr>
        <th></th>
        <th class="column-name">
          <div class="row-block">
            <input
              v-model="search_term"
              :placeholder="$tr('admin_console.companies.table.search')"
              @keyup.enter="search(search_term)"
            />
          </div>
        </th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <vacancy-row
        v-for="(item, index) in list"
        :key="item.id"
        :model="item"
        :company-id="companyId"
        :is_japan_locale="is_japan_locale"
      />
    </tbody>
  </table>
</template>

<script>
  import { STORE_PREFIX } from '../constants.js';
  import VacancyRow from './Row.vue';

  export default {
    name: 'VacancyList',

    components: {
      VacancyRow
    },

    props: {
      list: Array,
      companyId: null
    },

    data() {
      return {
        search_term: ''
      };
    },

    computed: {
      ...mapGetters(STORE_PREFIX + 'admin', {
        sorting: 'vacancies/sorting'
      }),

      sortingIcon() {
        return {
          'fa-caret-down': this.sorting.order === 'desc',
          'fa-caret-up': this.sorting.order === 'asc'
        };
      },

      is_japan_locale() {
        return this.$store.getters['locale/is_japan_locale'];
      }
    },

    methods: {
      fetch() {
        this.$store.dispatch(STORE_PREFIX + 'admin/vacancies/fetch', {
          company_id: this.companyId
        });
      },

      setSortingMethod(method) {
        const sorting = this.sorting;

        this.$store.dispatch(STORE_PREFIX + 'admin/vacancies/SET_SORTING', {
          name: method,
          order: sorting.name !== method || sorting.order === 'desc' ? 'asc' : 'desc'
        });

        this.fetch();
      },

      search() {
        this.$emit('search', this.search_term);
      }
    }
  };
</script>

<style lang="scss" scoped>
  table thead th {
    cursor: default;
    font-size: 14px;

    &.column-date span {
      white-space: normal;
      display: inline;
    }

    &.column-date,
    &.column-name,
    &.column-payment {
      cursor: pointer;
    }
  }

  .column-id {
    width: 4%;
  }

  .column-date {
    width: 11%;
  }

  .column-logo {
    width: 10%;
  }

  .column-name {
    width: 20%;
  }

  .column-payment {
    width: 10%;
  }

  .column-contact {
    width: 10%;
  }

  .column-location {
    width: 10%;
  }

  .column-user {
    width: 25%;
  }

  .vacancies-table {
    width: 100%;
    margin-top: 34px;

    &.admin-table {
      thead {
        tr:first-child {
          th {
            border-bottom: 1px solid #e5e5e5;
          }
        }
      }
    }
  }
</style>
